// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// function Navbar() {
//   const [isNavCollapsed, setIsNavCollapsed] = useState(true);
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       const topBar = document.querySelector(".top-bar");
//       if (!topBar) return;
//       const topBarHeight = topBar.offsetHeight;
//       if (window.scrollY > topBarHeight) {
//         document.body.classList.add("top-bar-hidden");
//       } else {
//         document.body.classList.remove("top-bar-hidden");
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleNavItemClick = (path) => {
//     setIsNavCollapsed(true);
//     navigate(path);
//   };

//   const getNavLinkClass = (path) => {
//     return location.pathname === path ? "nav-link active" : "nav-link";
//   };

//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-light">
//       {/* Top Bar */}
//       {/* <div className="container-fluid block top-bar">
//         <div className="top-address">
//           <ul>
//             <li>
//               <i className="fa-solid fa-location-dot" aria-hidden="true" />
//               Plot # 6, New Corporation Colony, North Ambajhari Rd, Nagpur - 440010
//             </li>
//             <li>
//               <i className="fa-solid fa-phone" aria-hidden="true" />
//               (O) 0712 - 2225435 (M) 9403964524
//             </li>
//             <li>
//               <i className="fa-regular fa-envelope" aria-hidden="true" />
//               info@nlfs.in
//             </li>
//           </ul>
//         </div>

//         <div className="top-social-link">
//           <ul>
//             <li>
//               <a
//                 href="https://www.facebook.com/people/NLF-Solutions-Pvt-Ltd/61572191486461/"
//                 className="facebook-icon"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <svg width={12} height={22} viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path
//                     d="M8.73264 3.93002C9.66946 3.93002 11.2504 3.93002 11.2504 3.93002V0.71875C11.2504 0.71875 10.1379 0.71875 8.67408 0.71875C7.21029 0.71875 3.63864 0.835524 3.63864 5.03936V7.72515H0.886719V11.0532H3.63864V21.446H7.62015V11.1116H10.8405L11.2504 7.78354H7.62015V5.09775C7.62015 5.09775 7.79581 3.93002 8.73264 3.93002Z"
//                     fill="#ffffff"
//                   />
//                 </svg>
//               </a>
//             </li>



// <li>
//   <a
//     href="https://www.instagram.com/nlfsolutions_pvt.ltd/"
//     className="instagram-icon"
//     target="_blank"
//     rel="noopener noreferrer"
//   >
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={22}
//       height={22}
//       viewBox="0 0 24 24"
//       fill="white"
//     >
//       <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3a3 3 0 1 1 0-6zm4.5-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
//     </svg>
//   </a>
// </li>



//            <li>
//   <a
//     href="https://www.linkedin.com/company/nlf-solutions-pvt-ltd/"
//     className="linkedin-icon"
//     target="_blank"
//     rel="noopener noreferrer"
//   >
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={22}
//       height={22}
//       viewBox="0 0 24 24"
//       fill="white"
//     >
//       <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.4 8.5h4.08V24H.4V8.5zm7.36 0h3.91v2.11h.06c.54-1.02 1.86-2.11 3.84-2.11 4.1 0 4.86 2.7 4.86 6.2V24h-4.08v-7.6c0-1.81-.03-4.14-2.53-4.14-2.53 0-2.92 1.98-2.92 4.02V24H7.76V8.5z" />
//     </svg>
//   </a>
// </li>

// <li>
//   <a
//     href="https://twitter.com/yourusername"
//     className="twitter-icon"
//     target="_blank"
//     rel="noopener noreferrer"
//   >
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={22}
//       height={22}
//       viewBox="0 0 24 24"
//       fill="white"
//     >
//       <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.724-.951.555-2.005.959-3.127 1.184-.897-.959-2.178-1.555-3.594-1.555-2.723 0-4.924 2.201-4.924 4.924 0 .39.045.765.127 1.124-4.094-.205-7.725-2.165-10.158-5.144-.424.729-.666 1.577-.666 2.475 0 1.708.869 3.216 2.188 4.099-.807-.026-1.566-.248-2.228-.616v.062c0 2.385 1.693 4.374 3.946 4.827-.413.112-.849.172-1.296.172-.317 0-.626-.031-.928-.089.627 1.956 2.444 3.377 4.6 3.418-1.68 1.317-3.809 2.103-6.115 2.103-.398 0-.79-.023-1.175-.069 2.179 1.397 4.768 2.213 7.557 2.213 9.054 0 14-7.496 14-13.986 0-.21 0-.423-.015-.634.962-.689 1.8-1.56 2.46-2.548l-.047-.02z" />
//     </svg>
//   </a>
// </li>



//           </ul>
//         </div>
//       </div> */}

//       {/* Main Navbar */}
//       <div className="container-fluid header-area">
//          <div>
//           <img src="NLFLogo.gif" width="150" alt="Right Logo" />
//         </div>
//         {/* <div style={{ width: '300px', height: '50px' }}>
//           <img src="../NLF.gif" alt="Logo" style={{ width: '100%', height: '100%' }} />
//         </div> */}

//         <button
//           className="navbar-toggler"
//           type="button"
//           onClick={() => setIsNavCollapsed(!isNavCollapsed)}
//           aria-controls="navbarNav"
//           aria-expanded={!isNavCollapsed}
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <div
//           className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse main-menu-area`}
//           id="navbarNav"
//         >
//           <ul className="navbar-nav mx-auto" style={{fontSize:15}}>
//             {[
//               { path: "/", label: "Home" },
//               { path: "/about-us", label: "About" },
//               { path: "/services", label: "Services" },
//               { path: "/products", label: "Products" },
//               { path: "/clientele", label: "Clientele" },
//               { path: "/blog", label: "Blogs" },
//               { path: "/case-study", label: "News & Events" },


//               { path: "/contact-us", label: "Contact Us" },
//               { path: "/careers", label: "Careers" },
//             ].map(({ path, label }) => (
//               <li className="nav-item" key={path}>
//                 <span
//                   className={getNavLinkClass(path)}
//                   onClick={() => handleNavItemClick(path)}
//                 >
//                   {label}
//                 </span>
//               </li>
//             ))}
//           </ul>
//         </div>


//       </div>
//     </nav>
//   );
// }

// export default Navbar;

import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

function Navbar() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavItemClick = (path) => {
    setIsNavCollapsed(true);
    navigate(path);
  };

  const getNavLinkClass = (path) => {
    return location.pathname === path ? "nav-link active" : "nav-link";
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      {/* Main Navbar */}
      <div className="container-fluid header-area">
        <div className="Navlogo">
          <img src="/Navlogo/NLFLogo.gif" width="140" alt="Right Logo" />
        </div>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsNavCollapsed(!isNavCollapsed)}
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse main-menu-area`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto" style={{ fontSize: 15 }}>
            {[
              // { path: "/", label: "Home" },
              // { path: "/about-us", label: "About" },
              // { path: "/services", label: "Services" },
              // { path: "/products", label: "Products" },
              // { path: "/clientele", label: "Clientele" },
              // { path: "/gallery", label: "Gallery" },
              // // { path: "/case-study", label: "News & Events" },
              // { path: "/careers", label: "Careers" },
              // { path: "/contact-us", label: "Contact Us" },

              { path: "/", label: "Home" },
              { path: "/about-us", label: "About" },
              { path: "/services", label: "Services" },
              { path: "/products", label: "Products" },
              { path: "/clientele", label: "Clientele" },
              { path: "/gallery", label: "Gallery" },
              // { path: "/blog", label: "Blog" },
              { path: "/careers", label: "Careers" },
              { path: "/contact-us", label: "Contact Us" },
            ].map(({ path, label }) => (
              <li className="nav-item" key={path}>
                <span
                  className={getNavLinkClass(path)}
                  onClick={() => handleNavItemClick(path)}
                >
                  {label}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

